const features = [
  {
    icon: 'ri-fire-line',
    title: '每日更新追踪',
    desc: '实时跟进韩国漫画连载动态，热门作品每日同步更新，确保你第一时间追到最新话。',
  },
  {
    icon: 'ri-medal-line',
    title: '高分榜单精选',
    desc: '结合热度数据与真实口碑，打造权威韩国漫画排行榜，帮你快速锁定高分必看佳作。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净阅读',
    desc: '无广告干扰、无恶意跳转，专注提供纯粹的韩国漫画在线阅读推荐体验。',
  },
  {
    icon: 'ri-compass-3-line',
    title: '全题材覆盖',
    desc: '从浪漫恋爱到热血动作，从奇幻冒险到悬疑惊悚，韩国漫画大全一站式满足你的所有偏好。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">特色优势</h2>
          <p className="mt-3 text-sm text-foreground-600">为什么选择我们 · 韩国漫画发现平台的独特价值</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-background-100 rounded-lg p-6 text-center group cursor-pointer hover:bg-background-200/70 transition-colors">
              <div className="w-14 h-14 mx-auto rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}